import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";

// import "./Table.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Table = () => {
  const web3Data = [
    {
      category: "Blockchain Platforms",
      tools: "Ethereum, Solana, Polygon, Optimism",
      includes: "L1 + L2 networks",
    },
    {
      category: "Smart Contracts",
      tools: "Solidity, Rust, Move",
      includes: "Hardhat, Foundry, Anchor",
    },
    {
      category: "Web3 Integration",
      tools: "Ethers.js, viem, WalletConnect",
      includes: "MetaMask, RainbowKit",
    },
    {
      category: "DApp Frontend",
      tools: "React, Next.js, Tailwind",
      includes: "Wagmi, TypeScript",
    },
    {
      category: "Backend Services",
      tools: "Node.js, NestJS, FastAPI",
      includes: "Go microservices",
    },
    {
      category: "Storage",
      tools: "IPFS, Filecoin, Arweave",
      includes: "NFT metadata, decentralized files",
    },
    {
      category: "Indexing",
      tools: "The Graph, Moralis, Covalent",
      includes: "Data indexing, APIs",
    },
    {
      category: "Infrastructure",
      tools: "Docker, Kubernetes, Terraform",
      includes: "Cloud deployments",
    },
    {
      category: "Security",
      tools: "Slither, Mythril, Defender",
      includes: "Audits and monitoring",
    },
  ];

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const rowVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 1,
        duration: 0.4,
      },
    }),
  };

  return (
    <div
      className="table-responsive"
      style={{
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      <table className="table table-bordered align-middle">
        {/* HEADER */}
        <thead className="table-light text-center">
          <tr
            style={{
              background: "linear-gradient(to right, #9d2482, #1513c1)",
              color: "#fff",
            }}
          >
            <th>Category</th>
            <th>Key Tools</th>
            <th>Includes</th>
          </tr>
        </thead>

        {/* BODY */}
        <tbody ref={ref}>
          {web3Data.map((row, index) => (
            <motion.tr
              key={index}
              custom={index}
              variants={rowVariant}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              style={{
                backgroundColor: index % 2 === 0 ? "#ffffff" : "#f3f0ff",
              }}
            >
              <td style={{ background: "", fontWeight: 800 }}>
                {row.category}
              </td>
              <td>{row.tools}</td>
              <td>{row.includes}</td>
            </motion.tr>
          ))}
          {/* {web3Data.map((row, index) => (
            <motion.tr
              key={index}
              custom={index}
              variants={rowVariant}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
            >
             
              <td
                style={{
                  background: index % 2 === 0 ? "#ffffff" : "#f3f0ff",
                  fontWeight: 800,
                }}
              >
                {row.category}
              </td>

              
              <td
                style={{
                  background: index % 2 === 0 ? "#f3f0ff" : "#ffffff",
                }}
              >
                {row.tools}
              </td>

              
              <td
                style={{
                  background: index % 2 === 0 ? "#ffffff" : "#f3f0ff",
                }}
              >
                {row.includes}
              </td>
            </motion.tr>
          ))} */}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
